<template>
    <b-modal
        id="copy-link-modal"
        title="Ecco il link dell'evento:"
        ok-only
        ok-title="Copia negli appunti"
    >
        <b-form-input
            :value="link"
            readonly
            ref="link"
        ></b-form-input>
        <template #modal-footer>
            <b-button class="btn btn-primary btn-rikorda1" @click="copyGalleryLink()">
                {{ $t("Copia negli appunti") }}
            </b-button>
        </template>
    </b-modal>
</template>

<script>
    import {BModal, BFormInput, BButton} from 'bootstrap-vue';

    export default {
        name: "CopyLink",
        components: {BModal, BFormInput, BButton},
        props: ["link"],
        methods: {
            copyGalleryLink() {
                let link = this.$refs.link.$el;
                link.select();
                try {
                    var successful = document.execCommand("copy");
                } catch (err) {
                    successful = false;
                }
                if (successful) {
                    this.$bvModal.hide("copy-link-modal");
                } else {
                    console.error("ERRORE COPIA LINK");
                }
                this.$emit('linkCopied', successful);
            }
        }
    }
</script>

<style scoped>

</style>
